export default [
    {
        path: "/meetnet/:id",
        component: () => import("@/views/meetnet/dashboard"),
        meta: { requiresAuth: true },
        children: [
            // Site
            {
                path: "site/",
                name: "sites",
                component: () => import("@/views/meetnet/site/siteDashboard"),
                meta: { requiresAuth: true },
            },
            {
                path: "site/:siteID/edit",
                name: "editSite",
                component: () => import("@/views/meetnet/site/editSite"),
                meta: { requiresAuth: true },
            },
            {
                path: "site/:siteID/installation/new",
                name: "newSensorInstallation",
                component: () => import("@/views/meetnet/site/newSensorInstallation"),
                meta: { requiresAuth: true },
            },
            {
                path: "site/:siteID/installation/:installID/edit",
                name: "editSensorInstallation",
                component: () => import("@/views/meetnet/site/editSensorInstallation"),
                meta: { requiresAuth: true },
            },
            {
                path: "site/new",
                name: "createSite",
                component: () => import("@/views/meetnet/site/createSite"),
                meta: { requiresAuth: true },
            },
            {
                path: "site/:siteID",
                name: "site",
                component: () => import("@/views/meetnet/site/siteDetails"),
                meta: { requiresAuth: true },
            },
            {
                path: "site/:siteID/data",
                name: "siteData",
                component: () => import("@/views/meetnet/site/siteData"),
                meta: { requiresAuth: true },
            },
            // Sensor
            {
                path: "sensor",
                name: "sensors",
                component: () => import("@/views/meetnet/sensor/sensorDashboard"),
                meta: { requiresAuth: true },
            },
            {
                path: "sensor/new",
                name: "createSensor",
                component: () => import("@/views/meetnet/sensor/createSensor"),
                meta: { requiresAuth: true },
            },
            {
                path: "sensor/:sensorID",
                name: "sensor",
                component: () => import("@/views/meetnet/sensor/sensorDetails"),
                meta: { requiresAuth: true },
            },
            {
                path: "sensor/:sensorID/edit",
                name: "editSensor",
                component: () => import("@/views/meetnet/sensor/editSensor"),
                meta: { requiresAuth: true },
            },
            {
                path: "/",
                redirect: "site/",
                meta: { requiresAuth: true },
            },
        ]
    },
];
